<template>
  <div class="progress-warp">
    <span class="progress-name">{{ progress.name }}</span>
    <div class="progress-line" :style="{width: progress.per}">
      <span class="num-unit">{{ progress.num }}家</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressItem',
  props: {
    progress: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="less" scoped>
  .progress-warp{
    padding-right: 60px;
  }
  .progress-name{
    font-size: 14px;
  }
  .progress-line{
    height: 8px;
    border-radius: 4px;
    margin: 6px 0;
    background: linear-gradient(to right, #2085E4, #35E8CE);
    position: relative;
    .num-unit{
      position: absolute;
      top: 50%;
      right: -20px;
      transform: translate(100%, -50%);
      width: 70px;
      line-height: 1;
      color: #fdca3a;
    }
  }
</style>
